import type { QueryClient } from "@tanstack/react-query";

export const APPROVAL_REFRESH_MS = 30_000;

export function approvalStatesKey(brandId: string) {
  return [`/api/brands/${brandId}/weekly-deliveries/approved-ads`] as const;
}

/** Disabled/hidden observers stay invalidated until they become eligible again. */
export function invalidateApprovalStates(client: QueryClient, brandId: string | undefined) {
  if (!brandId) return Promise.resolve();
  return client.invalidateQueries({ queryKey: approvalStatesKey(brandId), exact: true });
}
